import {
  CommonRequest,
  CommonResponse,
  DmlResponse,
  Method,
  ServiceName,
} from 'models/common/RestApi';
import { callApi } from 'utils/ApiUtil';
import {
  ActivityCondition,
  EqclGroup,
  PrjActivity,
  PrjActivityCondition,
  SpActivity,
  SpStep,
  WoGenerateResult,
} from 'models/setup/SetupActivity';

/* ── 셋업 단계별 Activity 마스터 ── */
export const findActivities = async (condition: ActivityCondition) => {
  const request: CommonRequest = {
    method: Method.GET,
    url: `/v1/setup/activity`,
    serviceName: ServiceName.ELM_BE,
    queryParams: new URLSearchParams({ ...condition }),
  };
  const response: CommonResponse<[]> = await callApi(request);
  return (response.successOrNot === 'Y' ? response.data : []) as SpActivity[];
};

export const findOrgEqclGroups = async (orgTpCd: string) => {
  const request: CommonRequest = {
    method: Method.GET,
    url: `/v1/setup/activity/eqcl-groups`,
    serviceName: ServiceName.ELM_BE,
    queryParams: new URLSearchParams({ orgTpCd }),
  };
  const response: CommonResponse<[]> = await callApi(request);
  return (response.successOrNot === 'Y' ? response.data : []) as EqclGroup[];
};

/** Activity별 대상 설비군 매핑 — Map<SP_ACTV_ID, Set<EQCL_ID>> 로 변환해 반환 */
export const findActivityEqclMap = async (params) => {
  const request: CommonRequest = {
    method: Method.GET,
    url: `/v1/setup/activity/eqcl-targets`,
    serviceName: ServiceName.ELM_BE,
    queryParams: new URLSearchParams({ ...(params || {}) }),
  };
  const response: CommonResponse<{ spActvId: string; eqclId: string }[]> = await callApi(request);
  return response;
  /*const map = new Map<string, Set<string>>();
  for (const r of response.data ?? []) {
    const set = map.get(r.spActvId) ?? new Set<string>();
    set.add(r.eqclId);
    map.set(r.spActvId, set);
  }
  return map;*/
};

/** 일괄 저장 (crudKey C/U/D) — 성공 시 처리 건수 반환 */
export const saveActivities = async (items: SpActivity[]) => {
  const request: CommonRequest = {
    method: Method.POST,
    url: `/v1/setup/activity`,
    serviceName: ServiceName.ELM_BE,
    bodyParams: items,
  };
  const response: CommonResponse<DmlResponse> = await callApi(request);
  return response;
};

/** 삭제 (USE_YN='N') */
export const deleteActivities = async (spActvIds: string[]) => {
  const request: CommonRequest = {
    method: Method.POST,
    url: `/v1/setup/sp-activity/delete`,
    serviceName: ServiceName.ELM_BE,
    bodyParams: { spActvIds },
  };
  const response: CommonResponse<DmlResponse> = await callApi(request);
  return response;
};

/* ── 프로젝트별 Activity ── */
export const findPrjActivities = async (condition: PrjActivityCondition) => {
  const request: CommonRequest = {
    method: Method.GET,
    url: `/v1/setup/project-activity`,
    serviceName: ServiceName.ELM_BE,
    queryParams: new URLSearchParams({ ...condition }),
  };
  const response: CommonResponse<[]> = await callApi(request);
  return (response.successOrNot === 'Y' ? response.data : []) as PrjActivity[];
};

/** [기준 Activity 가져오기] 후보 — 설비군 대상은 마스터 기준으로 이미 채워져 반환된다 */
export const findActivityCandidates = async (
  elmPrjId: string,
  orgTpCd: string,
  istlDivsCd: string
) => {
  const request: CommonRequest = {
    method: Method.GET,
    url: `/v1/setup/project-activity/candidates`,
    serviceName: ServiceName.ELM_BE,
    queryParams: new URLSearchParams({ elmPrjId, orgTpCd, istlDivsCd }),
  };
  const response: CommonResponse<[]> = await callApi(request);
  return (response.successOrNot === 'Y' ? response.data : []) as PrjActivity[];
};

export const savePrjActivities = async (items: PrjActivity[]) => {
  const request: CommonRequest = {
    method: Method.POST,
    url: `/v1/setup/project-activity`,
    serviceName: ServiceName.ELM_BE,
    bodyParams: items,
  };
  const response: CommonResponse<DmlResponse> = await callApi(request);
  return response;
};

/**
 * [W/O 생성] — 체크된 Activity 기준으로 WO + 담당자별 TO-DO 를 서버에서 일괄 생성한다.
 * (로컬 개발 도구는 화면에서 SQL을 구성해 실행했지만, 레거시에서는 이 한 번의 호출로
 *  Service 가 대상 조회·발행일 계산·채번·저장을 모두 트랜잭션으로 처리한다.)
 */
export const generatePrjWo = async (elmPrjId: string, spActvIds: string[]) => {
  const request: CommonRequest = {
    method: Method.POST,
    url: `/v1/setup/project-activity/generate-wo`,
    serviceName: ServiceName.ELM_BE,
    bodyParams: { elmPrjId, spActvIds },
  };
  const response: CommonResponse<WoGenerateResult> = await callApi(request);
  return response;
};
